/*
  assets/hub-shop-by-category.js
  ---------------------------------------------------------------------------
  A pedido: en "Shop by category" (Nivel 1, sections/collection-hub.liquid),
  el nombre de una categoría con hijos Nivel 3 propios abre un dropdown
  flotante con esos hijos, en vez de navegar — la imagen sigue yendo directo
  a Nivel 2 (ver snippets/hub-shop-by-category-card.liquid, que ya trae el
  markup y el <a> de la imagen sin tocar).

  position: fixed (no absolute) calculado acá, no en CSS puro: la fila
  "Shop by category" es un carril con scroll horizontal propio
  (overflow-x: auto en .hub__children), que recortaría cualquier
  position: absolute anclado a la tarjeta. fixed + coordenadas leídas de
  getBoundingClientRect() del botón evita ese recorte sin importar cuánto
  haya scrolleado el carril.

  Un solo dropdown abierto a la vez. Se cierra con: click afuera o Escape.
  Un scroll (de la página o del propio carril horizontal de las tarjetas)
  NO lo cierra — antes sí lo hacía y se sentía como un bug real ("se cierra
  solo al hacer scroll"), así que ahora en cambio se REPOSICIONA en cada
  scroll (vía requestAnimationFrame, para no recalcular en cada pixel),
  siguiendo al botón para no desalinearse.
*/
(function () {
  'use strict';

  var openToggle = null;
  var openDropdown = null;

  function closeOpen() {
    if (!openToggle) return;
    openToggle.setAttribute('aria-expanded', 'false');
    openDropdown.hidden = true;
    openDropdown.style.top = '';
    openDropdown.style.left = '';
    openToggle = null;
    openDropdown = null;
  }

  function positionDropdown(toggle, dropdown) {
    // Se mide DESPUÉS de mostrarlo (dropdown.hidden = false) para que
    // getBoundingClientRect() del propio dropdown ya refleje su ancho real
    // (min(280px, 92vw)) al momento de clampear contra el viewport.
    var toggleRect = toggle.getBoundingClientRect();
    var dropdownRect = dropdown.getBoundingClientRect();
    var margin = 8;

    var left = toggleRect.left + toggleRect.width / 2 - dropdownRect.width / 2;
    var maxLeft = window.innerWidth - dropdownRect.width - margin;
    left = Math.max(margin, Math.min(left, maxLeft));

    var top = toggleRect.bottom + 6;
    // Si no entra abajo (toggle muy pegado al borde inferior), se abre
    // hacia arriba en su lugar en vez de salirse de la pantalla.
    if (top + dropdownRect.height > window.innerHeight - margin) {
      top = toggleRect.top - dropdownRect.height - 6;
    }
    top = Math.max(margin, top);

    dropdown.style.left = left + 'px';
    dropdown.style.top = top + 'px';
  }

  function openFor(toggle, dropdown) {
    if (openToggle === toggle) {
      closeOpen();
      return;
    }
    closeOpen();
    dropdown.hidden = false;
    positionDropdown(toggle, dropdown);
    toggle.setAttribute('aria-expanded', 'true');
    openToggle = toggle;
    openDropdown = dropdown;
  }

  document.querySelectorAll('[data-hub-shop-card-toggle]').forEach(function (toggle) {
    var dropdown = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!dropdown) return;

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      openFor(toggle, dropdown);
    });
  });

  document.addEventListener('click', function (event) {
    if (!openDropdown) return;
    if (openDropdown.contains(event.target) || openToggle.contains(event.target)) return;
    closeOpen();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !openToggle) return;
    var toggleToRefocus = openToggle;
    closeOpen();
    toggleToRefocus.focus();
  });

  // capture + passive: atrapa el scroll de CUALQUIER contenedor con scroll
  // propio (incluido .hub__children, el carril horizontal de las propias
  // tarjetas), no solo el scroll de la ventana. rAF-throttled: un scroll
  // dispara decenas de eventos por segundo, pero solo hace falta
  // reposicionar una vez por frame pintado.
  var repositionScheduled = false;
  window.addEventListener('scroll', function () {
    if (!openToggle || repositionScheduled) return;
    repositionScheduled = true;
    window.requestAnimationFrame(function () {
      repositionScheduled = false;
      if (openToggle) positionDropdown(openToggle, openDropdown);
    });
  }, { capture: true, passive: true });

  // El resize (rotar el celular, achicar la ventana en escritorio) puede
  // dejar el dropdown fuera de pantalla si no se recalcula también acá.
  window.addEventListener('resize', function () {
    if (openToggle) positionDropdown(openToggle, openDropdown);
  }, { passive: true });
})();
